export const ORDER_CHAT_THREAD_PREFIX = 'order:';

export function buildOrderChatThreadId(userId: string | number, orderId: string): string {
  const uid = String(userId || '').trim();
  const oid = String(orderId || '').trim();
  return `${ORDER_CHAT_THREAD_PREFIX}${uid}:${oid}`;
}

export function isOrderChatThreadId(threadId: string | null | undefined): boolean {
  return String(threadId || '').startsWith(ORDER_CHAT_THREAD_PREFIX);
}

export function parseOrderChatThreadId(
  threadId: string | null | undefined
): { userId: string; orderId: string } | null {
  const raw = String(threadId || '');
  if (!isOrderChatThreadId(raw)) return null;
  const body = raw.slice(ORDER_CHAT_THREAD_PREFIX.length);
  const sep = body.indexOf(':');
  if (sep <= 0) return null;
  const userId = body.slice(0, sep);
  const orderId = body.slice(sep + 1);
  if (!userId || !orderId) return null;
  return { userId, orderId };
}

export function orderChatShortId(orderId: string | null | undefined): string {
  const id = String(orderId || '').trim();
  if (!id) return '';
  const tail = id.split('-').pop();
  return tail && tail.length <= 12 ? tail : id.slice(-8);
}

export function resolveThreadKind(
  threadId: string,
  metaKind?: string | null
): 'consult' | 'order' {
  if (metaKind === 'order' || isOrderChatThreadId(threadId)) return 'order';
  return 'consult';
}
